import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";

export default function Kontakt() {
  return (
    <div data-testid="page-kontakt">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Kontakt</p>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter mt-6">
              So erreichen Sie mich.
            </h1>
            <p className="text-[#757067] font-light text-lg mt-8 max-w-xl">
              Bei Fragen oder kurzfristigen Einsätzen freue ich mich über Ihre Nachricht
              oder Ihren Anruf — auch außerhalb der Geschäftszeiten.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="relative w-full aspect-[4/3] overflow-hidden border border-[#E3DECE]">
              <img
                src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1600&q=80&auto=format&fit=crop"
                alt="Gastronomie-Ambiente"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="border-t border-[#E3DECE] pt-8">
            <Phone className="text-[#BA6D52]" size={24} strokeWidth={1.25} />
            <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52] mt-6">Telefon</p>
            <a
              href="tel:+4915127282560"
              data-testid="kontakt-phone"
              className="font-serif text-xl sm:text-2xl mt-3 block hover:text-[#BA6D52] transition-colors"
            >
              +49 151 27282560
            </a>
            <p className="text-sm text-[#757067] mt-2 font-light">
              Auch per WhatsApp erreichbar
            </p>
          </div>
          <div className="border-t border-[#E3DECE] pt-8">
            <Mail className="text-[#BA6D52]" size={24} strokeWidth={1.25} />
            <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52] mt-6">E-Mail</p>
            <a
              href="mailto:mietkoch@stutz-cuisine.com"
              data-testid="kontakt-email"
              className="font-serif text-xl sm:text-2xl mt-3 block break-all hover:text-[#BA6D52] transition-colors"
            >
              mietkoch@stutz-cuisine.com
            </a>
            <p className="text-sm text-[#757067] mt-2 font-light">
              Antwort innerhalb von 24 h
            </p>
          </div>
          <div className="border-t border-[#E3DECE] pt-8">
            <MapPin className="text-[#BA6D52]" size={24} strokeWidth={1.25} />
            <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52] mt-6">Einsatzgebiet</p>
            <p className="font-serif text-xl sm:text-2xl mt-3 leading-snug">
              Deutschland &amp; Österreich
            </p>
            <p className="text-sm text-[#757067] mt-2 font-light">
              Einsätze in beiden Ländern — sprechen Sie mich einfach an
            </p>
          </div>
        </div>
      </section>

      <section className="border-t border-[#E3DECE] bg-[#F2EFE9]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
          <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52]">Anfrageformular</p>
          <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mt-6 max-w-2xl mx-auto">
            Detaillierte Anfrage in unter einer Minute.
          </h2>
          <Link
            to="/anfrage"
            data-testid="kontakt-cta-anfrage"
            className="mt-10 inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors"
          >
            Zum Formular <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
